export const CORRECTION_EVENT_KIND = 1010;
